<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isToggleSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- Form -->
      <b-form
        class="p-2"
        @reset.prevent="resetForm"
      >

        <h6
          class="text-info"
        >
          <feather-icon icon="AlertCircleIcon" />
          <span class="align-middle ml-25">Detalle del Gasto</span>
        </h6>

        <hr style="border-top: 2px solid #00cfe8;margin-bottom: 1rem !important;margin-top: 0 !important;">
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="Comprobante"
              label-for="comprobante"
            >
              <b-form-input
                id="comprobante"
                v-model="formData.comprobante"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="Motivo Gasto"
              label-for="motivoGasto"
            >
              <b-form-input
                id="motivoGasto"
                v-model="formData.motivo"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="Monto"
              label-for="monto"
            >
              <b-form-input
                id="monto"
                v-model="formData.monto"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              label="Vendedor"
              label-for="Vendedor"
            >
              <v-select
                v-model="formData.vendedor"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="nombreCompleto"
                :options="selectVendedor"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="button"
            @click="saveForm"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
          >
            Cancelar
          </b-button>
        </div>

      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BRow, BCol, BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
// import moment from 'moment'
// BAvatar, BMedia,  BSpinner,BInputGroup
import Ripple from 'vue-ripple-directive'
import store from '@/store'

export default {
  components: {
    BRow,
    BCol,
    // BAvatar,
    // BMedia,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    // BInputGroup,
    BButton,
    vSelect,
    // BSpinner,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isToggleSidebar',
    event: 'update:is-toggle-sidebar',
  },
  props: {
    isToggleSidebar: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, { emit }) {
    const titleForm = ref('Agregar Gasto')
    const isBusy = ref(false)
    const vendedor = ref(null)
    const selectVendedor = ref([])
    const tiposDocument = ref([])
    const tipoDocSel = ref(null)
    const formData = ref({})
    const fotoReniec = ref('')
    const cargos = ref(['GERENTE GENERAL', 'GERENTE OPERACIONES', 'GERENTE RRHH', 'SUPERVISOR COMERCIAL ZONAL', 'SUPERVISOR GRANEL', 'COORDINADOR OSINERGMIN', 'CAJERA', 'CONTADOR', 'JEFE DEPOSITO GASOCENTRO', 'JEFE PLATAFORMA', 'CONDUCTOR TRANSPORTE PRIMARIO', 'CONDUCTOR TRANSPORTE SECUNDARIO', 'VENDEDOR GRANEL', 'VENDEDOR CILINDROS', 'VENDEDOR DEPOSITO', 'VENDEDOR GASOCENTRO', 'VIGILANTE', 'DELIVERISTA'])
    const cargoSel = ref(null)
    const sexos = ref(['MASCULINO', 'FEMENINO'])
    const sexoSel = ref('MASCULINO')
    const readonlyFrm = ref(false)
    const tiposPersona = ref(['JURIDICA', 'NATURAL'])
    const tipoPersonaSel = ref('JURIDICA')
    const tiposProducto = ref(['CILINDRO', 'GRANEL', 'AMBOS'])
    const tipoProductoSel = ref('CILINDRO')
    const isJuridica = ref(true)
    const dptoSel = ref('220000')
    const provSel = ref(null)
    const distSel = ref(null)
    const dptos = ref([])
    const provs = ref([])
    const dists = ref([])
    const placeholderTP = ref('Ingrese RUC')
    const isGranel = ref(false)
    const isCilindro = ref(false)
    const userData = ref(JSON.parse(localStorage.getItem('userData')))
    const resetForm = () => {
      formData.value = {}
      fotoReniec.value = ''
    }
    const vendedorDefault = async () => {
      selectVendedor.value = []
      if (userData.value.authorities[0].authority === 'VENDEDOR CILINDROS' || userData.value.authorities[0].authority === 'VENDEDOR GRANEL' || userData.value.authorities[0].authority === 'VENDEDOR DEPOSITO' || userData.value.authorities[0].authority === 'VENDEDOR GASOCENTRO') {
        selectVendedor.value.push({ idUsuario: this.userData.id, nombreCompleto: this.userData.nombreCompleto })
        vendedor.value = { idUsuario: this.userData.id, nombreCompleto: this.userData.nombreCompleto }
      } else {
        selectVendedor.value = []
        // selectVendedor.value.push({ idUsuario: '-1', nombreCompleto: 'TODOS' })
        await store.dispatch('seguridad/USUARIO_ALL_SALES', { tipo_usuario: '-' })
          .then(response => {
            // console.log(response)
            response.forEach(value => {
              const { trabajador, ...resto } = value
              const nuevoObjeto = {
                nombreCompleto: trabajador.nombreCompleto,
                ...resto,
                trabajador,
              }
              selectVendedor.value.push(nuevoObjeto)
            })
          })
        // console.log(this.selectVendedor)
      }
    }
    const saveForm = async () => {
      // Validar datos antes

      if (formData.value.comprobante === null || formData.value.comprobante === '') {
        emit('error-data', { response: { data: { message: 'Debe ingresar el comprobante' } } })
        return
      }

      if (formData.value.motivo === null || formData.value.motivo === '') {
        emit('error-data', { response: { data: { message: 'Debe ingresar el motivo' } } })
        return
      }
      if (formData.value.monto === null || formData.value.monto === '') {
        emit('error-data', { response: { data: { message: 'Debe ingresar el monto' } } })
        return
      }

      let service = 'caja/GASTO_CREATE'
      if (props.formType === 'edit') {
        service = 'caja/GASTO_UPDATE'
      }
      // formData.value.tipoDocumento = tipoDocSel.value
      // formData.value.tipoPersona = tipoPersonaSel.value
      // formData.value.tipoProducto = tipoProductoSel.value
      // formData.value.ubigeo = {
      //  idUbigeo: distSel.value,
      // }

      await store.dispatch(service, formData.value)
        .then(response => {
          emit('refetch-data', response)
          emit('update:is-toggle-sidebar', false)
        })
        .catch(error => {
          emit('error-data', error)
          emit('update:is-toggle-sidebar', false)
        })
    }

    const isReadOnly = () => {
      if (tipoDocSel.value && tipoDocSel.value.id === 1) return true
      return false
    }

    const toggleSidebar = async val => {
      emit('update:is-toggle-sidebar', val)
      resetForm()
      await vendedorDefault()
      if (props.formType === 'new') {
        titleForm.value = 'Agregar Gasto'
      }
      if (props.formType === 'edit') {
        formData.value = {
          idGasto: props.dataEdit.idGasto,
          comprobante: props.dataEdit.comprobante,
          monto: props.dataEdit.monto,
          motivo: props.dataEdit.motivo,
          vendedor: props.dataEdit.vendedor,
          fecha: props.dataEdit.fecha,
          estado: props.dataEdit.estado,
        }
        formData.value.vendedor.nombreCompleto = props.dataEdit.vendedor.trabajador.nombreCompleto
        titleForm.value = 'Editar Cliente'
      }
    }
    return {
      titleForm,
      isBusy,
      tiposDocument,
      tipoDocSel,
      formData,
      fotoReniec,
      saveForm,
      toggleSidebar,
      isReadOnly,
      cargos,
      cargoSel,
      sexos,
      sexoSel,
      resetForm,
      readonlyFrm,
      tiposPersona,
      tipoPersonaSel,
      isJuridica,
      dptoSel,
      provSel,
      distSel,
      dptos,
      provs,
      dists,
      placeholderTP,
      tiposProducto,
      tipoProductoSel,
      isGranel,
      isCilindro,
      vendedor,
      selectVendedor,
      vendedorDefault,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
